import axios from "axios"

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function PurchaseInfosApi(props) {
    return {
        searchList: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/purchase-infos/searchList`, body, {
                params,
                headers
            })
        },
        createOne: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/purchase-infos/createOne`, body, {
                params,
                headers
            })
        },
        updateList: async ({ params, headers, body }) => {
            return await axios.put(`${MAIN_API_HOST}/purchase-infos/updateList`, body, {
                params,
                headers
            })
        },
        deleteOne: async ({ params, headers, body }) => {
            return await axios.delete(`${MAIN_API_HOST}/purchase-infos/deleteOne`, {
                params,
                headers
            })
        }
    }
}